import { takeLatest, put } from 'redux-saga/effects';
import { saveAs } from 'file-saver';
import {
  DOWNLOAD_FILE,
  setMarketingFiles,
  LOAD_MARKETING_FILES
} from './reducer';
import { getRequest, handleSagaError } from '../../utilities/requests';
import { history } from '../../utilities/history';

function* downloadfileEffect(action) {
  try {
    const url = action.url;
    const response = yield getRequest(url, {}, { responseType: 'blob' });
    saveAs(response.data, action.fileName);
  } catch (error) {
    handleSagaError(
      error,
      'Unable to download file at this time. Please try again later.'
    );
  }
}

export function* marketingSaga() {
  yield takeLatest(DOWNLOAD_FILE, downloadfileEffect);
}

function* handleLoadMarketingFiles() {
  try {
    const url = '/marketing_files';
    const response = yield getRequest(url);
    yield put(setMarketingFiles(response.data));
  } catch (error) {
    history.push('/error');
  }
}

export function* loadMarketingFilesSaga() {
  yield takeLatest(LOAD_MARKETING_FILES, handleLoadMarketingFiles);
}
